import { formatMoney } from "../lib/formatMoney";
import type { MenuModifierList } from "../lib/menuTypes";

type ModifierListProps = {
  list: MenuModifierList;
};

export function ModifierList({ list }: ModifierListProps) {
  return (
    <div className="modifier-list">
      <div className="modifier-list__heading">
        <span>
          {list.name}
          {typeof list.sharedPrice === "number" ? (
            <strong className="modifier-list__shared-price"> {formatMoney(list.sharedPrice)} each</strong>
          ) : null}
        </span>
        {renderSelectionHint(list.minSelected, list.maxSelected)}
      </div>
      <div className="modifier-list__items">
        {list.modifiers.map((modifier) => (
          <span className={`modifier-chip${modifier.isSoldOut ? " modifier-chip--sold-out" : ""}`} key={modifier.id}>
            {modifier.imageUrl ? <img src={modifier.imageUrl} alt="" loading="lazy" decoding="async" /> : null}
            {modifier.name}
            {modifier.isSoldOut ? <em>Sold out</em> : null}
            {typeof modifier.displayPrice === "number" ? (
              <strong>{formatMoney(modifier.displayPrice)}</strong>
            ) : typeof modifier.price === "number" && modifier.price > 0 && typeof list.sharedPrice !== "number" ? (
              <strong>+{formatMoney(modifier.price)}</strong>
            ) : null}
          </span>
        ))}
      </div>
    </div>
  );
}

function renderSelectionHint(minSelected?: number, maxSelected?: number) {
  if (typeof minSelected !== "number" && typeof maxSelected !== "number") return null;
  if (typeof maxSelected === "number" && maxSelected > 0) return <small>Up to {maxSelected}</small>;
  if (minSelected === maxSelected && typeof minSelected === "number") return <small>Choose {minSelected}</small>;
  if (typeof minSelected === "number" && minSelected > 0) return <small>At least {minSelected}</small>;
  return null;
}
